(() => {
  'use strict';
  function mediaRole(text) {
    const value = String(text || '').trim().toLowerCase();
    if (/unframed paper print corner detail$/.test(value)) return 'paper';
    if (/stretched canvas corner detail$/.test(value)) return 'canvas';
    const match = value.match(/\b(black|white|(?:natural\s+)?oak)\s+(stock paper frame|floater frame) corner detail$/);
    if (!match) return null;
    const finish = match[1].includes('oak') ? 'oak' : match[1];
    return `${match[2] === 'stock paper frame' ? 'stock' : 'floater'}_${finish}`;
  }
  function choiceRole(text) {
    const value = String(text || '').toLowerCase();
    if (/no floater/.test(value)) return 'canvas';
    if (/^no frame$/.test(value)) return 'paper';
    const finish = /oak|natural/.test(value) ? 'oak' : /white/.test(value) ? 'white' : /black/.test(value) ? 'black' : null;
    return finish ? `${/floater/.test(value) ? 'floater' : 'stock'}_${finish}` : null;
  }
  if (typeof module !== 'undefined') module.exports = { mediaRole, choiceRole };
  if (typeof document === 'undefined') return;
  const config = document.getElementById('905print-gallery-options-config');
  if (!config || window.__905GalleryOptions) return;
  window.__905GalleryOptions = true;
  const root = document.querySelector('.product-single__meta')?.closest('[data-section-id]') || document;
  // The native carousel can retain the original landscape image's height.
  const slides = Array.from(root.querySelectorAll('.product-main-slide'));
  function fitGallery() {
    const selected = slides.find(slide => slide.classList.contains('is-selected'));
    const viewport = selected?.closest('.flickity-viewport');
    const height = selected?.getBoundingClientRect().height;
    if (viewport && height > 0 && Math.abs(viewport.getBoundingClientRect().height - height) > 1) {
      viewport.style.height = `${height}px`;
    }
  }
  const galleryObserver = new MutationObserver(fitGallery);
  const galleryResize = new ResizeObserver(fitGallery);
  slides.forEach(slide => {
    galleryObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
    galleryResize.observe(slide);
  });
  fitGallery();
  const notice = document.createElement('p');
  notice.setAttribute('role', 'status');
  notice.setAttribute('aria-live', 'polite');
  notice.hidden = true;
  const options = root.querySelector('.po-buttonOption-optionItem');
  const noticeHost = root.querySelector('.product-single__meta') || options?.parentElement || document.querySelector('.product-slideshow')?.parentElement;
  noticeHost?.append(notice);
  let operation = 0, applying = false, nativeClick = false, timer;
  const visible = element => element && element.getClientRects().length > 0;
  const thumbs = () => Array.from(document.querySelectorAll('a.product__thumb'));
  const imageRole = thumb => mediaRole(thumb?.querySelector('img')?.alt);
  const swatches = () => Array.from(root.querySelectorAll('.po-imageOption-swatchLabel')).filter(visible);
  const material = wanted => Array.from(root.querySelectorAll('.po-buttonOption-optionItem')).find(label => {
    const text = label.querySelector('.po-buttonOption-label')?.textContent.trim();
    return visible(label) && (wanted === 'canvas' ? /^Gicl[e\u00e9]e Canvas$/i : /^Gicl[e\u00e9]e (Paper|Matte Print)$/i).test(text || '');
  });
  function nativeShow(role) {
    const thumb = thumbs().find(item => imageRole(item) === role) || (role === 'paper' ? thumbs()[0] : null);
    if (!thumb || thumb.classList.contains('is-active')) return;
    nativeClick = true;
    try { thumb.click(); } finally { nativeClick = false; }
  }
  function currentRole() {
    const selected = swatches().find(item => item.classList.contains('po-imageOption-checked'));
    return selected ? choiceRole(selected.querySelector('img')?.alt) : (material('paper') && !swatches().length ? 'paper' : null);
  }
  function waitForChoice(role, ticket) {
    return new Promise(resolve => {
      let observer;
      const finish = value => { observer?.disconnect(); window.clearTimeout(timeout); resolve(value); };
      const check = () => {
        if (ticket !== operation) return finish(null);
        const target = swatches().find(item => choiceRole(item.querySelector('img')?.alt) === role);
        if (target) finish(target);
        else if (role === 'paper' && material('paper') && !swatches().length) finish({ implicitPaper: true });
      };
      const timeout = window.setTimeout(() => finish(null), 1800);
      observer = new MutationObserver(check);
      observer.observe(root === document ? document.body : root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style'] });
      check();
    });
  }
  async function selectFromGallery(role) {
    const ticket = ++operation;
    applying = true;
    notice.hidden = true;
    window.clearTimeout(timer);
    try {
      const targetMaterial = material(role === 'canvas' || role.startsWith('floater_') ? 'canvas' : 'paper');
      if (!targetMaterial) {
        nativeShow('paper');
        notice.textContent = 'A size must be selected before a finish can be selected.';
        notice.hidden = false;
        return;
      }
      const current = currentRole();
      const needsCanvas = role === 'canvas' || role.startsWith('floater_');
      const currentCanvas = current === 'canvas' || current?.startsWith('floater_');
      if (needsCanvas !== currentCanvas || !current) targetMaterial.click();
      if (role === 'paper' && !swatches().length) return;
      const swatch = await waitForChoice(role, ticket);
      if (ticket !== operation) return;
      if (!swatch) {
        nativeShow(currentRole() || 'paper');
        notice.textContent = 'This frame is unavailable for the selected size.';
        notice.hidden = false;
        return;
      }
      if (!swatch.implicitPaper && !swatch.classList.contains('po-imageOption-checked')) swatch.click();
    } finally {
      if (ticket === operation) applying = false;
    }
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || nativeClick) return;
    const dot = event.target.closest('.flickity-page-dots .dot');
    if (dot && root.contains(dot)) {
      const index = Array.from(dot.parentElement.children).indexOf(dot);
      const role = imageRole(thumbs()[index]) || (index === 0 ? 'paper' : null);
      if (role) selectFromGallery(role);
      return;
    }
    const thumb = event.target.closest('a.product__thumb');
    if (thumb) {
      const role = imageRole(thumb) || (thumb === thumbs()[0] ? 'paper' : null);
      if (role) selectFromGallery(role);
      return;
    }
    if (applying || !event.target.closest('.po-buttonOption-optionItem, .po-imageOption-swatchLabel')) return;
    notice.hidden = true;
    ++operation;
    window.clearTimeout(timer);
    timer = window.setTimeout(() => { const role = currentRole(); if (role) nativeShow(role); }, 220);
  }, true);
  let observedRole, optionTimer;
  const optionObserver = new MutationObserver(() => {
    window.clearTimeout(optionTimer);
    optionTimer = window.setTimeout(() => {
      if (applying) return;
      const role = currentRole();
      if (!role) return;
      if (observedRole !== undefined && observedRole !== role) nativeShow(role);
      observedRole = role;
    }, 220);
  });
  optionObserver.observe(root === document ? document.body : root, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
  });
})();
